// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".department-form[data-v-ff3de9fc]{max-width:800px;margin:0 auto}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/department/components/DepartmentEditDialog.vue"],"names":[],"mappings":"AACA,kCACC,eAAA,CACA,aAAA","file":"DepartmentEditDialog.vue","sourcesContent":["\n.department-form {\n\tmax-width: 800px;\n\tmargin: 0 auto;\n}\n"]}]);
// Exports
module.exports = exports;
